// react
import React, { forwardRef, useState } from "react";
import { Hotkey } from "../../Hotkey";
import css from "./autogrow.styl";

export const AutoGrowTextArea = forwardRef(({ value, onChange, onKeyDown, onEnter }, ref) => {
	const [isFocused, setIsFocused] = useState(false);

	const handleKeyDown = (e) => {
		if (e.key === "Enter" && isFocused && onEnter) {
			e.preventDefault();
			onEnter();
		} else if (e.key === "Escape" && isFocused) {
			e.preventDefault();
			ref?.current?.blur();
		}

		onKeyDown?.(e);
	};

	return (
		<div
			className={css.autoGrowInput}
			style={{
				display: "inline-grid",
				alignItems: "stretch",
				padding: 8,
				border: "1px solid #ccc",
				borderRadius: 4,
			}}
		>
			<textarea
				ref={ref}
				rows="1"
				value={value}
				onChange={(event) => onChange(event.target.value)}
				onKeyDown={handleKeyDown}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				style={{
					gridArea: "1 / 1 / 2 / 2",
					width: "100%",
					padding: 0,
					border: "none",
				}}
			/>
			<span
				style={{
					gridArea: "1 / 1 / 2 / 2",
					visibility: "hidden",
					whiteSpace: "pre-wrap",
					lineHeight: "1.1",
				}}
			>
				{value}{" "}
			</span>

			{onEnter && isFocused ? (
				<div className={css.hotkeyContainer}>
					<Hotkey className={css.hotkey} shade="medium">
						Enter
					</Hotkey>
				</div>
			) : null}
		</div>
	);
});
